import { AxiosResponse } from "axios";
import { getAxiosInstance } from "./api-utils";
import { OrderHit } from "@/model/order-hit.schema";

const TASKS = "/tasks";

export interface TaskRow {
    productId: number;
    productCode: string;
    productIcon: string | null;
    orderedQuantity: number;
    actualQuantity: number;
}

export interface TaskField {
    key: string;
    value: string;
}

/** One open order as the crew sees it on the Tasks page. */
export interface TaskItem {
    order: OrderHit;
    dispatcherNotes: string | null;
    employeeNotes: string | null;
    blockedReason: string | null;
    recurringInterval: number | null;
    rows: TaskRow[];
    fields: TaskField[];
}

export interface TaskQuantity {
    productId: number;
    actualQuantity: number;
}

/** Open tasks for one day (paused ones included), express first then route order. */
export async function getTasks(date: Date, resourceId: number | null): Promise<TaskItem[]> {
    const response: AxiosResponse<TaskItem[]> = await getAxiosInstance().get(TASKS, {
        params: { date: date.toISOString(), resourceId },
    });
    return response.data;
}

export async function completeTask(orderId: number, quantities: TaskQuantity[], comment: string) {
    await getAxiosInstance().post(`${TASKS}/${orderId}/complete`, { quantities, comment });
}

export async function pauseTask(orderId: number, reason: string) {
    await getAxiosInstance().post(`${TASKS}/${orderId}/pause`, { reason });
}

export async function resumeTask(orderId: number) {
    await getAxiosInstance().post(`${TASKS}/${orderId}/resume`);
}
